export const removeFields = (v,keys) => {
    return Object.fromEntries(Object.entries(v).filter(([k,v])=>!keys.includes(k)))
}

export const set = (json,key,value) => ({...json,[key]:value})